import React from 'react';
import { FaCheck } from 'react-icons/fa';
import './TemplateManagement.css';

const TemplateWizardStepIndicator = ({
  steps,
  currentStep,
  onStepClick,
  isStepCompleted,
  maxWidth = '900px'
}) => {
  const completed = (stepNumber) => {
    if (typeof isStepCompleted === 'function') return isStepCompleted(stepNumber);
    return currentStep > stepNumber;
  };

  return (
    <div className="emtpl-steps" style={{ maxWidth }}>
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <button
            type="button"
            className="emtpl-step-btn"
            onClick={() => onStepClick?.(step.number)}
            aria-current={currentStep === step.number ? 'step' : undefined}
          >
            <div
              className={`emtpl-step-circle${
                currentStep === step.number
                  ? ' active'
                  : completed(step.number)
                  ? ' completed'
                  : ''
              }`}
            >
              {completed(step.number) ? <FaCheck /> : step.number}
            </div>
            <span
              className={`emtpl-step-label${
                currentStep === step.number ? ' active' : ''
              }`}
            >
              {step.title}
            </span>
          </button>

          {index < steps.length - 1 && (
            <div
              className={`emtpl-step-line${
                currentStep > step.number ? ' completed' : ''
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default TemplateWizardStepIndicator;
